/**
 * The `Message` action on another fan's profile and on a pool member's detail
 * pane. It opens the one-to-one chat in Messages through `useOpenPrivateChat`,
 * whether or not the chat still needs the other fan's approval, because the
 * first message is written there. Failures go through the shared error modal
 * and the fan stays where they are.
 */
import { Button } from "@sportsmet/ui";
import type { ReactNode } from "react";

import { useOpenPrivateChat } from "../messages/useOpenPrivateChat";
import { MESSAGE_ACTION_LABEL } from "./fanProfileCopy";

export type typeFanMessageActionProps = {
  accountId: string;
};

export const FanMessageAction = (
  props: typeFanMessageActionProps,
): ReactNode => {
  const { openPrivateChat, isPending } = useOpenPrivateChat();

  return (
    <Button
      onClick={() => {
        void openPrivateChat(props.accountId);
      }}
      disabled={isPending}
      data-testid="fan-message-action"
    >
      {MESSAGE_ACTION_LABEL}
    </Button>
  );
};
